export default Object.freeze({
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
});
